
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/packages/[slug]/page/[pageNum]",
      function () {
        return require("private-next-pages/packages/[slug]/page/[pageNum].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/packages/[slug]/page/[pageNum]"])
      });
    }
  